import { useSidebarPrefs } from 'pixelize-design-library';
import { Box, Flex } from 'pixelize-design-library';
import { Suspense, type ReactNode } from 'react';
import { Outlet } from 'react-router-dom';

import { GlobalSearchPalette } from '@modules/shared/components/GlobalSearchPalette';
import { useAppTheme } from '@core/Theme/useAppTheme';
import { canvas } from '@core/Theme/tokens';
import { DeferredFallback } from '@core/components/Loading/DeferredFallback';

import AppNavBar from './NavBar';
import AppSidebar from './Sidebar';

interface AppLayoutProps {
  children?: ReactNode;
}

export function AppLayout({ children }: AppLayoutProps) {
  const sb = useSidebarPrefs();
  const { colors } = useAppTheme();

  return (
    <Flex h='100dvh' w='100%' overflow='hidden' bg={canvas(colors)}>
      <GlobalSearchPalette />
      <AppSidebar
        mobileOpen={sb.mobileOpen}
        onMobileClose={sb.closeMobile}
        mobileNav={sb.mobileNav}
        onToggleMobileNav={sb.onToggleMobileNav}
        collapsed={sb.collapsed}
        onToggleCollapsed={sb.toggleCollapsed}
      />

      <Flex flex='1' direction='column' minH={0} minW={0} w='100%' overflow='hidden'>
        <Box flexShrink={0} w='100%'>
          <AppNavBar
            onSidebarToggle={sb.toggleMobileOpen}
            isSidebarOpen={sb.mobileOpen}
            forceSidebarToggle={sb.mobileNav}
          />
        </Box>

        <Box as='main' flex='1' overflowY='auto' p={{ base: 4, md: 6, lg: 8 }} w='100%' minW={0}>
          <Suspense fallback={<DeferredFallback minH='40vh' />}>{children ?? <Outlet />}</Suspense>
        </Box>
      </Flex>
    </Flex>
  );
}

export default AppLayout;
